import React from "react";
import { Card, Button, CalendarDate, MarkerPin01, MusicNote01 } from "@opendate-app/setlist";
import SeatPill from "../../../shared/SeatPill";
import { useResaleListingsContext } from "../ResaleListingsContext";
import { formatLongDate, formatVenueShortLine, buildSeatPills } from "../../../shared/formattingUtils";

const EventDetailCard = ({ calendarEvent: calendarEventProp }) => {
  const ctx = useResaleListingsContext();
  const calendarEvent = calendarEventProp || ctx?.calendarEvent;

  let selectedTickets = [];
  if (ctx) {
    const { selectedTicketIds = [], listableTickets = [], step } = ctx;
    if (step >= 2) {
      selectedTickets = listableTickets.filter((t) => selectedTicketIds.includes(t.id));
    }
  }

  if (!calendarEvent) return null;

  const {
    name,
    image_url: imageUrl,
    start_time: startTime,
    venue,
    age_restriction: ageRestriction,
    reserved_seating: reservedSeating,
  } = calendarEvent;

  const {
    name: venueName,
    city: venueCity,
    state_code: venueState,
    address1: venueAddress1,
    address2: venueAddress2,
    zip: venueZip,
    outdoor: venueOutdoor,
  } = venue || {};

  const venueShortLine = formatVenueShortLine(venue);
  const venueAddressLine2 = [venueCity, venueState].filter(Boolean).join(", ");
  const venueAddressFull = [venueAddressLine2, venueZip].filter(Boolean).join(" ");

  const tags = [];
  if (ageRestriction) tags.push(ageRestriction);
  if (venueOutdoor) tags.push("Outdoor");
  if (reservedSeating) tags.push("Reserved Seating");

  const pills = buildSeatPills(selectedTickets);

  return (
    <Card padding="none">
      <div className="resale-event-card">
        <div className="resale-event-image-wrap">
        {imageUrl ? (
          <img src={imageUrl} alt={name || ""} className="resale-event-image" />
        ) : (
          <div className="resale-event-image resale-event-image-placeholder">
            <MusicNote01 width={32} height={32} aria-hidden="true" />
          </div>
        )}
      </div>

      <div className="resale-event-details">
        <h2 className="resale-event-title">{name}</h2>
        {startTime && (
          <div className="resale-event-info-row">
            <CalendarDate width={20} height={20} className="resale-event-info-icon" aria-hidden="true" />
            <span>{formatLongDate(startTime)}</span>
          </div>
        )}
        {venueShortLine && (
          <div className="resale-event-info-row">
            <MarkerPin01 width={20} height={20} className="resale-event-info-icon" aria-hidden="true" />
            <span>{venueShortLine}</span>
          </div>
        )}

        {(venueName || venueAddress1 || venueAddressFull) && (
          <div className="resale-event-section">
            <div className="resale-event-section-title">Venue Info</div>
            <div className="resale-event-section-body">
              {venueName && <div>{venueName}</div>}
              {(venueAddress1 || venueAddressFull) && (
                <div>
                  {[[venueAddress1, venueAddress2].filter(Boolean).join(", "), venueAddressFull]
                    .filter(Boolean)
                    .join(", ")}
                </div>
              )}
            </div>
            {tags.length > 0 && (
              <div className="resale-event-tag-row">
                {tags.map((t) => (
                  <SeatPill key={t}>{t}</SeatPill>
                ))}
              </div>
            )}
          </div>
        )}

        {pills.length > 0 && (
          <div className="resale-event-section resale-event-seats">
            <div className="resale-event-seats-header">
              <div className="resale-event-section-title resale-event-seats-title">
                Seat(s) Selected to Sell
              </div>
              {ctx?.setStep && (
                <Button variant="text" size="sm" className="resale-seats-edit" onClick={() => ctx.setStep(1)}>
                  Edit
                </Button>
              )}
            </div>
            <div className="resale-event-tag-row">
              {pills.map((p) => (
                <SeatPill key={p}>{p}</SeatPill>
              ))}
            </div>
          </div>
        )}
        </div>
      </div>
    </Card>
  );
};

export default EventDetailCard;
